export default class AktTextResult {
  public readonly id!: string;
  public readonly subscription_id!: string;
  public readonly text_version_id!: string;

  public value?: string;
}
